//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'settlement-tips',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    onOk(ev){
      this.$emit('input', false);
      ev.stopPropagation();
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/SettlementTips.vue